export const allBotStates = {
  
  leadPlatform: "Supply Chain",
  area: "CD Excellence",
  subArea: "Monthly Reporting",
  cluster: "Europe",
  mco: "Benelux",
  country: "Netherlands",
  primaryApplication: "SAP",
  applications: "SAP, Excel, Outlook, SP",
  toolUsed: "BP",
  deliveryModel: "Model 1",
  status: "Ideas",
  processID: "ULAFLMLMasterData",
  processName: "Master Data Anomaly Detection",
  processCriticality: "Critical Process",
  processDescription:
    "Bot extracts Promo Guidelines files for UK & Ireland, consolidates in master sheet and remove duplicates along with entering source file reference details and send it to UDL via Blob storage.",
  kfa: false,
  requestType: "New Request",
  requesterEmailID: "Shehara.Gamage@unilever.com",
  engagementLead: "kunal.kakkar@unilever.com",
  initiatedBy: "GEO IT",
  dataClassification: "Internal",
  buildName:
    "5024-ULBPFINMECU010PPVMonitoring_SQL;5024-ULBPFINMECU010PPVMonitoring_SAP_Master;5024-ULBPFINMECU010PPVMontoring_Email Notification;5024-ULBPFINMECU010PPVMonitoring_SAP_Base_Standard;5024-ULBPFINMECU010PPVMonitoring_SAP_Base_Custom",
  supportStatus: "Support Type",
  technology: "Ai",
  dateLogged: "2021-02-01",
  sopReceivedDate: "2021-02-01",
  tCode: "T97",
  hoursSavedYearly: "10",
  businessOwnerEmailID: "Shehara.Gamage@unilever.com",
  createdBy: "David Raj",
  numberOfRunsInAMonth: 10,
   averageTime: 50,
  sopDocument: "some documnets",
  parentBotID: "457",
  dateOfStatusChanged: "2021-02-01",
  commentsForStatusChanged: "Some Changes",
  kfaTransactional: false,
  kfaInformational: false,
  kfaIuc: false,
  remarks: "Good Remarks",
  pddDocument: "can be empty",
  pddApprovalDocument: "can be empty",
  sddDocument: "can be empty",
  qsgDocument: "can be empty",
  odiDocument: "can be empty",
  brdDocument: "can be empty",
  costApprovalDocument: "can be empty",
  explicitLandscapeApplicationOwnerApprovalDocument: "can be empty",
  explicitGPMApprovalSupplyChainFinanceDocument: "can be empty",
  explicitGFCFApprovalDocument: "can be empty",
  devQualityCredentialsAvailableDocument: "can be empty",
  infosecApprovalDocument: "can be empty",
  dAReviewSignOffDocument: "can be empty",
  testDataAvailableForDevelopmentDocument: "can be empty",
  requestRaisedForProductionCredentialsDocument: "can be empty",
  internalTestingCompletedDocument: "can be empty",
  peerReviewSignOffDocument: "can be empty",
  daReviewSecondSignOffDocument: "can be empty",
  bpReleaseSignOffFromDaDocument: "can be empty",
  uatScriptsWithResultsDocument: "can be empty",
  uatSignOffDocument: "can be empty",
  releaseManagerSignOffDocument: "can be empty",
  gateFormDocument: "can be empty",
  peerReviewchecklistDocument: "can be empty",
  qaSignOffDocument: "can be empty",
  walkthroughVideo: "can be empty",
  ktVideo: "can be empty",
  costApprovalDate: "2021-02-01",
  pddSignOffDate: "2021-02-01",
  testStartDate: "2021-02-01",
  goLiveDate: "2021-02-01",
  bauDate: "2021-02-01",
  lastModifiedDate: "2021-02-01",
  landscapeApprover: "ddddd",
  landscapeApproval: false,
  controlImpacted: "node ",
  nameofControlImpacted: "node",
  iuc: false,
  approvedBy: "node",
  approvalDate: "2021-02-01",
  infosecApprover: "node",
  infosecApproval: false,
};
export const imageBaseURL = "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/product/"

